<template>
  <v-sheet color="grey-lighten-3" class="pa-2 d-flex justify-center align-center rounded-t-xl">
    <v-btn v-on:click="go_to_quarters"  :icon="true" size="large" density="compact" rounded="xl" flat class="mr-1" variant="text">
      <v-icon :icon="['fas', 'arrow-left']" />
    </v-btn>
    <ZN_Filter />
    <v-sheet color="transparent" width="200">

      <v-sheet width="200" color="transparent">
        <v-progress-linear height="35" v-model="calendar.special.timeload.percent" :color="quarter_percent_color" rounded="xl">
          {{ quarter }} КВАРТАЛ {{ year }} ГОДА
        </v-progress-linear>
      </v-sheet>
      <v-tooltip activator="parent" location="bottom">
        <span class="font-weight-bold">ЗАГРУЗКА {{ calendar.special.timeload.percent }}%</span><br>
        <span class="font-weight-bold">ВСЕГО: </span>{{ calendar.special.timeload.freetime }} ч.<br>
        <span class="font-weight-bold">З.Н.: </span>{{ calendar.special.timeload.duration }} ч.
      </v-tooltip>
    </v-sheet>

    <v-spacer />
    <zn-helper />

    <v-btn :icon="true" size="large" density="compact" rounded="xl" flat class="mr-1" disabled v-if="editable">
      <v-icon :icon="['fas', 'calendar-day']" />
      <v-tooltip location="bottom end" activator="parent">
        ПРОШЛЫЙ КВАРТАЛ
      </v-tooltip>
    </v-btn>

    <v-btn :icon="true" size="large" density="compact" rounded="xl" flat class="ml mr-1" v-on:click="shuffled_fill()" v-if="documents && documents.length >= 2 && editable">
      <v-icon :icon="['fas', 'dice']" />
      <v-tooltip location="bottom end" activator="parent" class="text-center">
        В СВОБОДНОМ ПОРЯДКЕ<br>
        С УЧЁТОМ НАГРУЗКИ
      </v-tooltip>
    </v-btn>
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn v-bind="props" size="large" density="compact" rounded="xl" flat height="35" v-if="editable">
          ФАЙЛ
        </v-btn>
      </template>

      <v-list rounded="xl" elevation="0" width="300">
        <ZN_Printer />
        <v-list-item link v-on:click="save_calendar()">
          <template v-slot:append>
            <v-icon :icon="['fas', 'floppy-disk']" />
          </template>
          СОХРАНИТЬ
        </v-list-item>
        <v-divider />
        <v-alert rounded="0" color="red">
          <p>Перед созданием ТОиППР удостоверьтесь, что вы сохранили результаты работы!</p>
        </v-alert>
        <ZN_TOnPPR />
      </v-list>
    </v-menu>
  </v-sheet>
  <v-sheet width="100%" class="d-flex justify-center align-top gradiented" color="grey-lighten-3">
    <ZN_MonthCard v-for="month of calendar.months" :key="month" :month="month" :year="year" :editable="editable"/>
  </v-sheet>
</template>

<script>
import moment from "moment";
import { CurrentYear } from "@/store/zn_planner/CurrentYear";
import { CurrentYearCalendar } from "@/store/zn_planner/CalendarOfYear";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { Documents, OriginalDocuments, SelectedDocs } from "@/store/zn_planner/Documents";
import ZN_MonthCard from "@/components/zn_planner/ZN_MonthCard.vue";
import { shuffle } from "@/libs/utils";
import { Allerts } from "@/store/global/Allerts";
import ZN_Printer from "@/components/zn_planner/ZN_Printer.vue";
import ZN_Filter from "@/components/zn_planner/ZN_Filter.vue";
import { ZN_Filters } from "@/store/zn_planner/Filters";
import ZN_TOnPPR from "@/components/zn_planner/ZN_TOnPPR.vue";
import ZnHelper from "@/views/a_planner/elements/zn-helper.vue";

export default {
  name: 'QQuarterCard',
  components: {ZnHelper, ZN_TOnPPR, ZN_Filter, ZN_Printer, ZN_MonthCard },
  props: ['editable'],
  async beforeMount() {
    this.generate_fridays()
  },
  data() {
    return {
      size: 2,
      months: null,
      failed_docs: [],
      fridays: []
    }
  },
  methods: {
    moment,
    save_calendar: async function () {
      let raw = {
        district: this.district,
        quarter: this.quarter,
        year: this.year,
        days: this.gfdl()
      }
      console.log(raw)
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/ZN_SavePlannerData`
      let props = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      await fetch(url, props)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка сохранения Документов!`
            }
          })
          .then(result => {
            console.log(result)
            Allerts().warn('УСПЕХ!', `Документы успешно сохранены!`, '#68b616', 'check')
          }).catch(err => {
            Allerts().warn('ОШИБКА!', `${err}`, '#ff4422', 'triangle-exclamation')
            console.error(err)
          })
    },
    gfdl: function () {
      let days = []
      for (let month of this.calendar.months) {
        for (let day of month.days) {
          days.push(day)
        }
      }
      return days
    },
    generate_fridays: function () {
      this.calendar.months.map(month => {
        month.days.map(day => {
          if (day.weekday === 5) {
            this.fridays.push(day)
          }
        })
      })
    },
    go_to_quarters: function () {
      this.$router.push({ name: 'a__planner__y', params: { guid: this.$route.params.guid, year: moment().format('YYYY') } })
    },
    is_filtered(doc) {
      if (this.filters) {
        let agents = this.filters.agents
        let objects = this.filters.objects
        let types = this.filters.types
        let period = this.filters.period
        let chief = this.filters.chiefs

        let has_agents = agents.length > 0 ? agents.includes(doc.agent.guid) : true
        let has_objects = objects.length > 0 ? objects.includes(doc.object.guid) : true
        let has_types = types.length > 0 ? types.includes(doc.type.guid) : true
        let has_period = period.length > 0 ? period.includes(doc.period) : true
        let has_chief = chief.length > 0 ? chief.includes(doc.chief.guid) : true

        return has_agents && has_objects && has_types && has_period && has_chief
      } else {
        return true
      }
    },
    shuffled_fill: function () {
      this.documents = this.documents_o

      let shuffled = shuffle(this.documents.filter(doc => this.is_filtered(doc)))
      shuffled = shuffle(shuffled)

      let big_docs = shuffled.filter(doc => doc.duration > 10)
      let medium_docs = shuffled.filter(doc => doc.duration > 5 &&  doc.duration <= 10)
      let small_docs = shuffled.filter(doc => doc.duration <= 5)

      this.sort_documents(big_docs)
      this.sort_documents(medium_docs)
      this.sort_documents(small_docs)

      if (this.documents.length) {
        Allerts().warn('ОБРАТИТЕ ВНИМАНИЕ!', `У Вас осталось ${this.documents.length} нераспределённых документов!`, '#d07619', 'file')
      }

    },
    sort_documents: function (docs) {
      for (let doc of docs) {
        let days = this.gfdl()
        while (days.length > 0) {
          let day = this.get_r_day(days)
          // ВСЕ УСЛОВИЯ ПРОВЕРКИ ДНЕЙ
          if (this.valid_day(day, doc)) {
            this.place_document(day, doc)
            days = []
          }
          days.splice(days.indexOf(day), 1)
        }
      }
    },
    valid_day(day, doc) {
      let month = () => {
        let flag = null
        for (let [m_i, m] of this.calendar.months.entries()) {
          for (let d of m.days) {
            if (d.date === day.date) {
              flag = m_i
              break
            }
          }
        }
        return flag
      }
      let errors = []

      // Не рабочий текущий день
      if (day.hours.all === 0) {
        errors.push({
          id: 'not_working',
          name: 'Не рабочий день!'
        })
      }

      // В текущем дне нет свободного времени
      if (day.hours.free <= 0) {
        errors.push({
          id: 'out_of_time',
          name: 'Не достаточно времени!'
        })
      }
      // Заказ-наряд больше по продолжительности
      // чем свободное время выбранного дня
      if (day.hours.free < doc.duration) {
        errors.push({
          id: 'out_of_time',
          name: 'Не достаточно времени!'
        })
      }

      // Проверка периодичности заказ-наряда
      if (doc.period === 'Месяц') {
        if (month() !== doc.example-1) {
          errors.push({
            id: 'not_valid_period',
            name: 'Заказ-наряд не предназначен для данного месяца!'
          })
        }
      }

      // Проверка периодичности заказ-наряда
      if (doc.period === 'Неделя') {
        if (this.fridays[doc.example-1].date !== day.date) {
          errors.push({
            id: 'not_valid_period',
            name: 'Заказ-наряд не предназначен для данной недели!'
          })
        }
      }

      return errors.length === 0;
    },
    get_r_day: function (days) {
      return days[Math.floor(Math.random() * days.length)]
    },
    place_document: function (day, doc) {
      day.documents.push(doc)
      day.hours.free -= doc.duration
      day.hours.used += doc.duration

      let pos = this.documents.findIndex(d => d.guid === doc.guid)
      this.documents.splice(pos, 1)
    }
  },
  computed: {
    filters: {
      get() {
        return ZN_Filters().get()
      },
      set(value) {
        ZN_Filters().set(value)
      }
    },
    selected: {
      get() {
        return SelectedDocs().get()
      },
      set(value) {
        SelectedDocs().set(value)
      }
    },
    documents: {
      get() {
        return Documents().get()
      },
      set(value) {
        Documents().set(value)
      }
    },
    documents_o: {
      get() {
        return OriginalDocuments().get()
      },
      set(value) {
        OriginalDocuments().set(value)
      }
    },
    quarter_percent_color() {
      let p = this.calendar.special.timeload.percent

      if (p >= 0 && p < 66) {
        return '#90c90b'
      } else if (p >= 66 && p < 90) {
        return '#c94b0a'
      } else if (p >= 90 && p <= 100) {
        return '#a90c0c'
      } else {
        return '#000000'
      }
    },
    quarter() {
      return parseInt(this.$route.params.quarter)
    },
    district() {
      return this.$route.params.guid
    },
    year: {
      get() {
        return CurrentYear().get()
      },
      set(value) {
        CurrentYear().set(value)
      }
    },
    calendar: {
      get() {
        return CurrentYearCalendar().get()
      },
      set(value) {
        CurrentYearCalendar().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}

</script>

<style scoped>
.gradiented {
  background: rgb(238, 238, 238);
  background: -moz-linear-gradient(180deg, rgba(238, 238, 238, 1) 0%, rgba(255, 255, 255, 1) 34%, rgba(255, 255, 255, 1) 100%);
  background: -webkit-linear-gradient(180deg, rgba(238, 238, 238, 1) 0%, rgba(255, 255, 255, 1) 34%, rgba(255, 255, 255, 1) 100%);
  background: linear-gradient(180deg, rgba(238, 238, 238, 1) 0%, rgba(255, 255, 255, 1) 34%, rgba(255, 255, 255, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#eeeeee", endColorstr="#ffffff", GradientType=1);
}
</style>
